import React, { Component } from "react";
import {
    FormGroup,
    FormControl,
    Button,
    Alert
} from "react-bootstrap";
//import "./LoginForm.css";
import axios from "axios";
import cookie from 'react-cookie';

import mixpanel from 'mixpanel-browser';

import './content/content.css';

class ContactForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: {
                email: "",
                firstName: "",
                lastName: "",
                message: "",
                password: "",
                rememberMe: true,                
            },
            error: "",
            initialMessage: this.props.initialMessage,
            submitting: false,
            messageInputCollapsed: this.props.messageInputCollapsed
        };

        this.changeUser = this.changeUser.bind(this);
        
        this.mixpanel = mixpanel;

        this.messageInput = this.messageInput.bind(this);
        this.handleAddMessage = this.handleAddMessage.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);

        this.fetchUserData = this.fetchUserData.bind(this);
        this.messageWithContext = this.messageWithContext.bind(this);

	}

	componentDidMount() {        
		let jwt = cookie.load('webfinery.jwt', { path: '/'});
        if (jwt) {
			this.fetchUserData();
        }        
	}

	fetchUserData() {
		let that = this;
		axios
            .get("/api/account", {
                params: { }
            })
            .then(function(response) {            	
            	let user = { email: response.data.email, firstName: response.data.firstName };
                that.setState({ user: user });
            })
            .catch(function(error) {            	
                that.mixpanel.track("Search failed", {
                    success: false,
                    error: error,
                    isLoggedIn: that.state.isLoggedIn 
                });
            });	
	}

	messageWithContext() {
		let context = '[' + this.props.topic + '/' + this.props.contactModalPush + '/' + this.props.contactModalCue + '] ';
		return context + this.state.user.message;
	}
	
	handleSubmit(event) {
		event.preventDefault();
        this.setState({submitting: true});

       	let that = this;

       	let params = {
       		email: this.state.user.email,
       		list: this.props.list,
       		firstName: this.state.user.firstName,
       		lastName: this.state.user.lastName,
       		message: this.messageWithContext()
       	}

        axios
            .post("/api/newsletter/subscriptions", params)
            .then(function(response) {            	
                that.mixpanel.track("Contact Form Sent", {
                    email: params.email,
                    list: params.list,
                    firstName: params.firstName,
                    lastName: params.lastName,
                    message: params.message,
                    source: 'webfinery.com',
                    success: true
                });
                that.setState({ email: '', status: 'success', submitting: false });
            })
            .catch(function(error) {
                that.mixpanel.track("Contact Form Error Sending", {
                    email: params.email,
                    list: params.list,
                    firstName: params.firstName,
                    lastName: params.lastName,
                    message: params.message,
                    source: 'webfinery.com',
                    success: false,
                    error: error
                });
                that.setState({ status: 'error', submitting: false });
            });
	}    

    changeUser(event) {
        const field = event.target.name;
        const user = this.state.user;
        user[field] = event.target.value;

        this.setState({
            user: user,
            error: ""
        });
    }

    messageInput() {

    	const messageInputVisible = (
			<FormGroup>
                <FormControl
                	componentClass="textarea"
                    placeholder="Your message"
                    value={this.state.user.message}
                    onChange={this.changeUser}
                    name="message"
                    maxLength="1024"
                />
            </FormGroup>
    	)

    	const messageInputCollapsed = (
    		<div style={{textAlign: 'right'}}>
    			<Button bsSize="sm" onClick={this.handleAddMessage}>Add Message</Button>
    		</div>
    	)

    	return this.state.messageInputCollapsed ? messageInputCollapsed : messageInputVisible;
    }

    handleAddMessage() {
    	this.setState({messageInputCollapsed: false});
    }

    submittingLabel() {
    	return this.props.submittingLabel ? this.props.submittingLabel : "Sending...";
    }

    submitLabel() {
    	return this.props.submitLabel ? this.props.submitLabel : "Send";
    }

    successMessage() {
    	return (
    		<div className="contact-form-success">
    			<h3>Done!</h3>    			
    			<h4>Please expect to hear from us soon</h4>
    			<Button onClick={this.props.handleHide}>Close</Button>
    		</div>
    	)
    }

    form() {

        const errors = this.state.error
            ? <Alert bsStyle="danger">{this.state.error}</Alert>
            : <Alert />;

        const initialMessage = this.state.initialMessage
            ? <Alert bsStyle="info">{this.state.initialMessage}</Alert>
            : null;

        const submitLabel = this.state.submitting ? this.submittingLabel() : this.submitLabel();

    	return (
            <form action="/" className="contact-form" onSubmit={this.handleSubmit}>
                
                <FormGroup>
                    {initialMessage}
                    {errors}
                </FormGroup>
                
                <FormGroup>
                    <FormControl
                        type="text"
                        placeholder="First Name *"
                        value={this.state.user.firstName}
                        onChange={this.changeUser}
                        name="firstName"
                        required="required"
                    />
                </FormGroup>

                {this.props.lastNameVisible && (<FormGroup>
                    <FormControl
                        type="text"
                        placeholder="Last Name"
                        value={this.state.user.lastName}
                        onChange={this.changeUser}
                        name="lastName"
                        maxLength="255"
                    />
                </FormGroup>)}

                <FormGroup>
                    <FormControl
                        type="email"
                        placeholder="Work Email Address *"
                        value={this.state.user.email}
                        onChange={this.changeUser}
                        name="email"
                        maxLength="255"
                        required="required"
                    />
                </FormGroup>


                {this.messageInput()}
                <FormGroup>
                    <Button
                        disabled={this.state.submitting}
                        type="submit"
                        bsStyle="success"
                    >
                        {submitLabel}
                    </Button>                    
                </FormGroup>

            </form>    	
        )
    }



    render() {
        return this.state.status === 'success' ? this.successMessage() : this.form();
    }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/ContactForm.js